export default function Decision_Tree() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Decision_Tree</h1>
      <p>Content for Decision_Tree goes here.</p>
    </div>
  );
}